var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
export default Vue.extend({
    name: 'orangeLoanCreditApply',
    data: function () {
        return {
            mationForm: {
                realBusinessAddress: '',
                companyContactName: '',
                companyContactMobile: '',
                companyContactMail: '',
            },
            mationRules: {
                realBusinessAddress: [
                    { required: true, message: '请输入实际经营地址', trigger: 'blur' },
                    {
                        min: 2,
                        max: 40,
                        message: '长度在 2 到 40 个字符',
                        trigger: 'blur',
                    },
                ],
                companyContactName: [
                    { required: true, message: '请输入企业联系人姓名', trigger: 'blur' },
                    {
                        validator: this.validateMain,
                        trigger: 'blur',
                        reg: /^[\u4e00-\u9fa5+\·?\u4e00-\u9fa5+]{2,30}$/,
                        error: '请输入正确的姓名格式',
                    },
                ],
                companyContactMobile: [
                    { required: true, message: '请输入企业联系电话', trigger: 'blur' },
                    {
                        validator: this.validateMain,
                        trigger: 'blur',
                        reg: /^\s*[1]{1}[0-9]{10}\s*$/,
                        error: '手机号格式不正确',
                    },
                ],
                companyContactMail: [
                    { required: true, message: '请输入企业联系人邮箱', trigger: 'blur' },
                    {
                        validator: this.validateMain,
                        trigger: 'blur',
                        reg: /^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/,
                        error: '请输入正确的邮箱',
                    },
                ],
                isPartener: [
                    {
                        required: true,
                        message: '请选择是否有占股25%以上股东',
                        trigger: 'change',
                    },
                ],
                shareHolderName_0: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                    {
                        validator: this.validateMain,
                        trigger: 'blur',
                        reg: /^[\u4e00-\u9fa5+\·?\u4e00-\u9fa5+]{2,15}$/,
                        error: '请输入正确的姓名格式',
                    },
                ],
                shareHolderIdMobile_0: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    {
                        validator: this.validateMain,
                        trigger: 'blur',
                        reg: /^\s*[1]{1}[0-9]{10}\s*$/,
                        error: '手机号格式不正确',
                    },
                ],
                shareHolderIdNo_0: [
                    { required: true, message: '请输入身份证号', trigger: 'blur' },
                    {
                        validator: this.validateMain,
                        trigger: 'blur',
                        reg: /^\s*\d{17}\S{1}\s*$/,
                        error: '请输入有效的身份证号',
                    },
                ],
            },
            partenerList: [
                {
                    title: '一',
                },
            ],
        };
    },
    computed: __assign({ isShowPartener: function () {
            return this.isPartener;
        } }, mapState('info', {
        merchantBasicInfo: 'merchantBasicInfo',
        merchantOperationInfo: 'merchantOperationInfo',
    })),
    created: function () {
        this.$emit('get-credit-status', {
            creditStatus: 0,
            stepStatus: 0,
        });
    },
    methods: {
        returnApply: function () {
            this.$router.push({ name: 'orangeLoanHome', query: { query: true } });
        },
        validateMain: function (rule, value, callback) {
            var reg = rule.reg, error = rule.error;
            if (reg.test(value)) {
                return callback();
            }
            return callback(new Error(error));
        },
        submitBase: function () {
            var _this = this;
            // this.$router.push({name: 'orangeLoanResult'})
            var mationForm = this.mationForm;
            this.$refs['mationForm'].validate(function (valid) {
                if (!valid) {
                    return;
                }
                var realBusinessAddress = mationForm.realBusinessAddress, companyContactName = mationForm.companyContactName, companyContactMobile = mationForm.companyContactMobile, companyContactMail = mationForm.companyContactMail;
                var _a = _this.merchantBasicInfo, fullName = _a.fullName, merchantRegisterAddress = _a.merchantRegisterAddress;
                var _b = _this.merchantOperationInfo, legalPersonName = _b.legalPersonName, legalPersonIdentityCode = _b.legalPersonIdentityCode, businessLicenseNo = _b.businessLicenseNo, registerCapital = _b.registerCapital, legalPersonIdentityUrlFront = _b.legalPersonIdentityUrlFront, legalPersonIdentityUrlBack = _b.legalPersonIdentityUrlBack, businessLicenseUrl = _b.businessLicenseUrl, bankAccountLicenseUrl = _b.bankAccountLicenseUrl, legalPersonCellPhone = _b.legalPersonCellPhone;
                var shareHolderList = [];
                for (var _i = 0, _c = Object.keys(mationForm); _i < _c.length; _i++) {
                    var key = _c[_i];
                    if (key.includes('shareHolderName') ||
                        key.includes('shareHolderIdMobile') ||
                        key.includes('shareHolderIdNo')) {
                        var nameArr = key.split('_');
                        var index = Number(nameArr[1]);
                        var name = nameArr[0];
                        if (!shareHolderList[index]) {
                            shareHolderList[index] = {};
                        }
                        shareHolderList[index][name] = mationForm[key];
                    }
                }
                var params = {
                    companyName: fullName,
                    registerNumber: businessLicenseNo,
                    // registerDate: '',
                    registerMoney: registerCapital,
                    registerAddress: merchantRegisterAddress,
                    legalPersonName: legalPersonName,
                    legalPersonIdNo: legalPersonIdentityCode,
                    legalPersonMobile: legalPersonCellPhone,
                    realBusinessAddress: realBusinessAddress,
                    companyContactName: companyContactName,
                    companyContactMobile: companyContactMobile,
                    companyContactMail: companyContactMail,
                    businessLicenceAttachmentUrl: businessLicenseUrl,
                    openPremitAttachmentUrl: bankAccountLicenseUrl,
                    legalPersonIdFrontUrl: legalPersonIdentityUrlFront,
                    legalPersonIdReverseUrl: legalPersonIdentityUrlBack,
                    shareHolderList: shareHolderList,
                };
                _this.$request({
                    method: 'post',
                    url: '/proxy/oneCar/api/credit/apply',
                    data: __assign({}, params),
                }).then(function (res) {
                    if (!res)
                        return;
                    if (res && !res.errorCode) {
                        _this.$router.push({
                            name: 'orangeLoanCreditStatus',
                            query: { status: 3 },
                        });
                    }
                });
            });
        },
        addPartener: function () {
            var list = this.partenerList;
            var len = list.length;
            if (len >= 4) {
                return this.$message({
                    message: '最多添加4个股东',
                    type: 'warning',
                });
            }
            var changeText = function (num) {
                var text = '';
                switch (num) {
                    case 0:
                        text = '一';
                        break;
                    case 1:
                        text = '二';
                        break;
                    case 2:
                        text = '三';
                        break;
                    case 3:
                    default:
                        text = '四';
                }
                return text;
            };
            list.push({ title: changeText(len) });
            this.mationRules["shareHolderName_" + len] = [
                { required: true, message: '请输入姓名', trigger: 'blur' },
                {
                    validator: this.validateMain,
                    trigger: 'blur',
                    reg: /^[\u4e00-\u9fa5+\·?\u4e00-\u9fa5+]{2,15}$/,
                    error: '请输入正确的姓名格式',
                },
            ];
            this.mationRules["shareHolderIdMobile_" + len] = [
                { required: true, message: '请输入手机号', trigger: 'blur' },
                {
                    validator: this.validateMain,
                    trigger: 'blur',
                    reg: /^\s*[1]{1}[0-9]{10}\s*$/,
                    error: '手机号格式不正确',
                },
            ];
            this.mationRules["shareHolderIdNo_" + len] = [
                { required: true, message: '请输入身份证号', trigger: 'blur' },
                {
                    validator: this.validateMain,
                    trigger: 'blur',
                    reg: /^\s*\d{17}\S{1}\s*$/,
                    error: '请输入有效的身份证号',
                },
            ];
        },
        deletePartener: function (index) {
            delete this.mationForm["shareHolderName_" + index];
            delete this.mationForm["shareHolderIdMobile_" + index];
            delete this.mationForm["shareHolderIdNo_" + index];
            this.partenerList.splice(index, 1);
        },
    },
});
